<div class="ibox detailed-view-ibox" *ngIf="settingsParcelsService.showDetailedView">
    <div class="detailed-view-header">
        <div class="detailed-view-amenity-name">Parcel Settings</div>
        <div style="font-size: 15px;">
            {{settingsParcelsService.selectedItemData ? settingsParcelsService.selectedItemData.corporationNumberName : ''}}
        </div>
        <span class="close-detailed-view" (click)="settingsParcelsService.toggleDetailedView(null, false)">×</span>
    </div>
    <div>
        <div class="detailed-view-body">
            <div class="detailed-view__more-info m-t-md" *ngIf="settingsParcelsService.selectedItemData">
                <form #form="ngForm" submittable autocomplete="off">
                    <div>
                        <div class="detailed-view-navigation  btn-group btn-group-justified">
                            <div class="col-md-6 col-sm-6 col-xs-6 no-padding btn">
                                <div class="button-section"
                                     (click)="navPosition = 'general';"
                                     [ngStyle]="{'background-color': navPosition == 'general' ? '#ebebeb' : ''}">
                                    General
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-xs-6 no-padding btn">
                                <div class="button-section"
                                     (click)="navPosition = 'notifications';"
                                     [ngStyle]="{'background-color': navPosition == 'notifications' ? '#ebebeb' : ''}">
                                    Notifications
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="general-tab" *ngIf="navPosition == 'general'">
                        <div class="settings-amenities-slider-container">
                            <span>Use Barcode Scanner</span>
                            <mat-slide-toggle name="useBarcodeScannerStatus"
                                              (change)="onSubmit({useBarcodeScannerStatus: form.value.useBarcodeScannerStatus ? 1 : 0})"
                                              [ngModel]="settingsParcelsService.selectedItemData.useBarcodeScannerStatus">
                            </mat-slide-toggle>
                        </div>
                        <hr>
                        <div class="settings-amenities-slider-container">
                            <span>Use signature & Show reference signature</span>
                            <mat-slide-toggle name="useSignaturePadStatus"
                                              (change)="onSubmit({useSignaturePadStatus: form.value.useSignaturePadStatus ? 1 : 0, showReferenceSignatureStatus: form.value.useSignaturePadStatus ? 1 : 0})"
                                              [ngModel]="settingsParcelsService.selectedItemData.useSignaturePadStatus">
                            </mat-slide-toggle>
                        </div>
                        <hr>
                        <!--<div class="settings-amenities-slider-container">-->
                            <!--<span>Show Reference Signature</span>-->
                            <!--<mat-slide-toggle name="showReferenceSignatureStatus"-->
                                              <!--(change)="onSubmit({showReferenceSignatureStatus: form.value.showReferenceSignatureStatus ? 1 : 0})"-->
                                              <!--[ngModel]="settingsParcelsService.selectedItemData.showReferenceSignatureStatus">-->
                            <!--</mat-slide-toggle>-->
                        <!--</div>-->
                        <!--<hr>-->
                        <div class="settings-amenities-slider-container">
                            <span>Show Resident Photo</span>
                            <mat-slide-toggle name="showResidentPhotoStatus"
                                              (change)="onSubmit({showResidentPhotoStatus: form.value.showResidentPhotoStatus ? 1 : 0})"
                                              [ngModel]="settingsParcelsService.selectedItemData.showResidentPhotoStatus">
                            </mat-slide-toggle>
                        </div>

                        <hr>

                        <div class="row m-b-sm" (dblclick)="isFromEditMode = true;">
                            <div class="dv-label col-sm-4">
                                <label>Email Sender Email</label>
                            </div>
                            <div class="dv-value col-sm-8 fourteenPixelText" *ngIf="!isFromEditMode">
                                <span>{{settingsParcelsService.selectedItemData.emailSender || '-'}}</span>
                                <i class="fa fa-pencil pull-right"
                                   (click)="isFromEditMode = true;"
                                   data-toggle="tooltip" data-placement="top" title="Edit"></i>
                            </div>
                            <div class="dv-value-edit col-sm-8 fourteenPixelText" *ngIf="isFromEditMode">
                                <input name="emailSender"
                                       class="form-control"
                                       type="email"
                                       maxlength="255"
                                       pattern="^[0-9a-zA-Z_\.\-\+]+@[0-9a-zA-Z_.-]+?\.[0-9a-zA-Z]{2,3}$"
                                       (keyup.enter)="isChangedEmailValid(form.value.emailSender)"
                                       [ngModel]="settingsParcelsService.selectedItemData.emailSender">
                                <button type="button"
                                        [disabled]="disabledSenderSubmit"
                                        (click)="isChangedEmailValid(form.value.emailSender)">
                                    <i class="fa fa-check"></i>
                                </button>
                                <button type="button" (click)="isFromEditMode = false;">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>

                        <div class="row m-b-sm"
                             (dblclick)="setEditModeFor(settingsParcelsService.selectedItemData, 'emailSenderName', true)">
                            <div class="dv-label col-sm-4">
                                <label>Email Sender Name</label>
                            </div>
                            <div class="dv-value col-sm-8 fourteenPixelText"
                                 *ngIf="!settingsParcelsService.selectedItemData.formFields.emailSenderName.editMode">
                                <span>{{settingsParcelsService.selectedItemData.emailSenderName || '-'}}</span>
                                <i class="fa fa-pencil pull-right"
                                   (click)="setEditModeFor(settingsParcelsService.selectedItemData, 'emailSenderName', true)"
                                   data-toggle="tooltip" data-placement="top" title="Edit"></i>
                            </div>
                            <div class="dv-value-edit col-sm-8 fourteenPixelText"
                                 *ngIf="settingsParcelsService.selectedItemData.formFields.emailSenderName.editMode">
                                <input name="emailSenderName"
                                       class="form-control"
                                       maxlength="255"
                                       (keyup.enter)="applyChanges(settingsParcelsService.selectedItemData, form, {emailSenderName: form.value.emailSenderName}, 'emailSenderName')"
                                       [ngModel]="settingsParcelsService.selectedItemData.emailSenderName">
                                <button type="button"
                                        [disabled]="disabledSenderSubmit"
                                        (click)="applyChanges(settingsParcelsService.selectedItemData, form, {emailSenderName: form.value.emailSenderName}, 'emailSenderName')">
                                    <i class="fa fa-check"></i>
                                </button>
                                <button type="button" (click)="setEditModeFor(settingsParcelsService.selectedItemData, 'emailSenderName', false)">
                                    <i class="fa fa-times"></i>
                                </button>
                            </div>
                        </div>
                        <hr>
                        <div class="lists-section">
                            <span>Lists</span>
                            <ul>
                                <li class="mtv-primary-color"
                                    (click)="settingsParcelsService.isPackageTypeModalShow = true;">
                                    Package Types
                                </li>
                                <li class="mtv-primary-color"
                                    (click)="settingsParcelsService.isCouriersModalShow = true;">
                                    Couriers
                                </li>
                                <!--<li class="mtv-primary-color" (click)="settingsParcelsService.isStorageLocationsModalShow = true;">-->
                                    <!--Storage Locations-->
                                <!--</li>-->
                            </ul>
                        </div>
                    </div>
                    <div *ngIf="navPosition == 'notifications'">
                        <div class="settings-amenities-slider-container">
                            <span>Notify Staff</span>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsParcelsService.parcelReceivedStaffCheckbox"
                                       name="parcelReceivedStaffCheckbox"
                                       id="parcelReceivedStaffCheckbox"
                                       [disabled]="!emailTemplateIsSet('staff', 'received')"
                                       (change)="submitNotificationsField()">
                                <label for="parcelReceivedStaffCheckbox"
                                       [title]="!emailTemplateIsSet('staff', 'received') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('staff', 'received')">
                                Parcel Received
                            </span>
                        </div>
                        <div class="m-b-xs" *ngIf="settingsParcelsService.parcelReceivedStaffCheckbox">
                            <multiselect-field name="receivedStaffMultiselectArray"
                                               [data]="settingsParcelsService.userRoles"
                                               [(ngModel)]="settingsParcelsService.receivedStaffMultiselectArray"
                                               (update)="submitNotificationsField()">
                            </multiselect-field>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsParcelsService.parcelPickedUpStaffCheckbox"
                                       name="parcelPickedUpStaffCheckbox"
                                       id="parcelPickedUpStaffCheckbox"
                                       [disabled]="!emailTemplateIsSet('staff', 'pickedUp')"
                                       (change)="submitNotificationsField()">
                                <label for="parcelPickedUpStaffCheckbox"
                                       [title]="!emailTemplateIsSet('staff', 'pickedUp') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('staff', 'pickedUp')">
                                Parcel Picked Up
                            </span>
                        </div>
                        <div class="m-b-xs" *ngIf="settingsParcelsService.parcelPickedUpStaffCheckbox">
                            <multiselect-field name="pickedUpStaffMultiselectArray"
                                               [data]="settingsParcelsService.userRoles"
                                               [(ngModel)]="settingsParcelsService.pickedUpStaffMultiselectArray"
                                               (update)="submitNotificationsField()">
                            </multiselect-field>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsParcelsService.parcelReturnedStaffCheckbox"
                                       name="parcelReturnedStaffCheckbox"
                                       id="parcelReturnedStaffCheckbox"
                                       [disabled]="!emailTemplateIsSet('staff', 'returned')"
                                       (change)="submitNotificationsField()">
                                <label for="parcelReturnedStaffCheckbox"
                                       [title]="!emailTemplateIsSet('staff', 'returned') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('staff', 'returned')">
                                Parcel Returned
                            </span>
                        </div>
                        <div class="m-b-xs" *ngIf="settingsParcelsService.parcelReturnedStaffCheckbox">
                            <multiselect-field name="returnedStaffMultiselectArray"
                                               [data]="settingsParcelsService.userRoles"
                                               [(ngModel)]="settingsParcelsService.returnedStaffMultiselectArray"
                                               (update)="submitNotificationsField()">
                            </multiselect-field>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsParcelsService.parcelCanceledStaffCheckbox"
                                       name="parcelCanceledStaffCheckbox"
                                       id="parcelCanceledStaffCheckbox"
                                       [disabled]="!emailTemplateIsSet('staff', 'canceled')"
                                       (change)="submitNotificationsField()">
                                <label for="parcelCanceledStaffCheckbox"
                                       [title]="!emailTemplateIsSet('staff', 'canceled') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('staff', 'canceled')">
                                Parcel Canceled
                            </span>
                        </div>
                        <div class="m-b-xs" *ngIf="settingsParcelsService.parcelCanceledStaffCheckbox">
                            <multiselect-field name="canceledStaffMultiselectArray"
                                               [data]="settingsParcelsService.userRoles"
                                               [(ngModel)]="settingsParcelsService.canceledStaffMultiselectArray"
                                               (update)="submitNotificationsField()">
                            </multiselect-field>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsParcelsService.parcelModifiedStaffCheckbox"
                                       name="parcelModifiedStaffCheckbox"
                                       id="parcelModifiedStaffCheckbox"
                                       [disabled]="!emailTemplateIsSet('staff', 'modified')"
                                       (change)="submitNotificationsField()">
                                <label for="parcelModifiedStaffCheckbox"
                                       [title]="!emailTemplateIsSet('staff', 'modified') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('staff', 'modified')">
                                Parcel Modified
                            </span>
                        </div>
                        <div class="m-b-xs" *ngIf="settingsParcelsService.parcelModifiedStaffCheckbox">
                            <multiselect-field name="modifiedStaffMultiselectArray"
                                               [data]="settingsParcelsService.userRoles"
                                               [(ngModel)]="settingsParcelsService.modifiedStaffMultiselectArray"
                                               (update)="submitNotificationsField()">
                            </multiselect-field>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsParcelsService.parcelDeletedStaffCheckbox"
                                       name="parcelDeletedStaffCheckbox"
                                       id="parcelDeletedStaffCheckbox"
                                       [disabled]="!emailTemplateIsSet('staff', 'deleted')"
                                       (change)="submitNotificationsField()">
                                <label for="parcelDeletedStaffCheckbox"
                                       [title]="!emailTemplateIsSet('staff', 'deleted') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('staff', 'deleted')">
                                Parcel Deleted
                            </span>
                        </div>
                        <div class="m-b-xs" *ngIf="settingsParcelsService.parcelDeletedStaffCheckbox">
                            <multiselect-field name="deletedStaffMultiselectArray"
                                               [data]="settingsParcelsService.userRoles"
                                               [(ngModel)]="settingsParcelsService.deletedStaffMultiselectArray"
                                               (update)="submitNotificationsField()">
                            </multiselect-field>
                        </div>
                        <hr>
                        <div class="settings-amenities-slider-container">
                            <span>Notify Residents</span>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       id="parcelReceivedResidentCheckbox"
                                       name="parcelReceivedResidentCheckbox"
                                       [(ngModel)]="settingsParcelsService.parcelReceivedResidentCheckbox"
                                       [disabled]="!emailTemplateIsSet('residents', 'received')"
                                       (change)="submitNotificationsField()">
                                <label for="parcelReceivedResidentCheckbox"
                                       [title]="!emailTemplateIsSet('residents', 'received') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('residents', 'received')">
                                Parcel Received
                            </span>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       id="parcelPickedUpResidentCheckbox"
                                       name="parcelPickedUpResidentCheckbox"
                                       [(ngModel)]="settingsParcelsService.parcelPickedUpResidentCheckbox"
                                       [disabled]="!emailTemplateIsSet('residents', 'pickedUp')"
                                       (change)="submitNotificationsField()">
                                <label for="parcelPickedUpResidentCheckbox"
                                       [title]="!emailTemplateIsSet('residents', 'pickedUp') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('residents', 'pickedUp')">
                                Parcel Picked Up
                            </span>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       id="parcelReturnedResidentCheckbox"
                                       name="parcelReturnedResidentCheckbox"
                                       [(ngModel)]="settingsParcelsService.parcelReturnedResidentCheckbox"
                                       [disabled]="!emailTemplateIsSet('residents', 'returned')"
                                       (change)="submitNotificationsField()">
                                <label for="parcelReturnedResidentCheckbox"
                                       [title]="!emailTemplateIsSet('residents', 'returned') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('residents', 'returned')">
                                Parcel Returned
                            </span>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       id="parcelCanceledResidentCheckbox"
                                       name="parcelCanceledResidentCheckbox"
                                       [(ngModel)]="settingsParcelsService.parcelCanceledResidentCheckbox"
                                       [disabled]="!emailTemplateIsSet('residents', 'canceled')"
                                       (change)="submitNotificationsField()">
                                <label for="parcelCanceledResidentCheckbox"
                                       [title]="!emailTemplateIsSet('residents', 'canceled') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('residents', 'canceled')">
                                Parcel Canceled
                            </span>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsParcelsService.parcelModifiedResidentCheckbox"
                                       name="parcelModifiedResidentCheckbox"
                                       id="parcelModifiedResidentCheckbox"
                                       [disabled]="!emailTemplateIsSet('residents', 'modified')"
                                       (change)="submitNotificationsField()">
                                <label for="parcelModifiedResidentCheckbox"
                                       [title]="!emailTemplateIsSet('residents', 'modified') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('residents', 'modified')">
                                Parcel Modified
                            </span>
                        </div>
                        <div class="m-b-xs filter-checkbox">
                            <label class="img-checkbox">
                                <input type="checkbox"
                                       [(ngModel)]="settingsParcelsService.parcelDeletedResidentCheckbox"
                                       name="parcelDeletedResidentCheckbox"
                                       id="parcelDeletedResidentCheckbox"
                                       [disabled]="!emailTemplateIsSet('residents', 'deleted')"
                                       (change)="submitNotificationsField()">
                                <label for="parcelDeletedResidentCheckbox"
                                       [title]="!emailTemplateIsSet('residents', 'deleted') ? 'Please select email template first' : ''">
                                    <svg-checked></svg-checked>
                                </label>
                            </label>
                            <span class="mtv-primary-color clickable-text"
                                  (click)="showNotificationModal('residents', 'deleted')">
                                Parcel Deleted
                            </span>
                        </div>

                        <hr>

                        <div>
                            <span class="mtv-primary-color clickable-text" (click)="showReminderTextModal()">
                                Email Reminder Text
                            </span>
                        </div>

                        <hr *ngIf="account.canRead('sms') &&
                                   settingsParcelsService.smsSettings?.twilioSettings?.sid &&
                                   settingsParcelsService.smsSettings?.twilioSettings?.friendlyName">

                        <div *ngIf="account.canRead('sms') &&
                                   settingsParcelsService.smsSettings?.twilioSettings?.sid &&
                                   settingsParcelsService.smsSettings?.twilioSettings?.friendlyName">
                            <div class="settings-amenities-slider-container">
                                <span>Notify Residents by SMS</span>
                            </div>
                            <div class="m-b-xs filter-checkbox">
                                <label class="img-checkbox">
                                    <input type="checkbox"
                                           id="parcelReceivedSmsResidentCheckbox"
                                           name="parcelReceivedSmsResidentCheckbox"
                                           [(ngModel)]="settingsParcelsService.parcelReceivedSmsResidentCheckbox"
                                           [disabled]="smsCheckboxDisabled('residentsSms', 'received')"
                                           (change)="submitNotificationsField()">
                                    <label for="parcelReceivedSmsResidentCheckbox"
                                           [title]="smsCheckboxDisabled('residentsSms', 'received') ? 'Please select email template first' : ''">
                                        <svg-checked></svg-checked>
                                    </label>
                                </label>
                                <span class="mtv-primary-color clickable-text"
                                      (click)="showNotificationModal('residentsSms', 'received')">
                                    Parcel Received
                                </span>
                            </div>
                            <div class="m-b-xs filter-checkbox">
                                <label class="img-checkbox">
                                    <input type="checkbox"
                                           id="parcelPickedUpSmsResidentCheckbox"
                                           name="parcelPickedUpSmsResidentCheckbox"
                                           [(ngModel)]="settingsParcelsService.parcelPickedUpSmsResidentCheckbox"
                                           [disabled]="smsCheckboxDisabled('residentsSms', 'pickedUp')"
                                           (change)="submitNotificationsField()">
                                    <label for="parcelPickedUpSmsResidentCheckbox"
                                           [title]="smsCheckboxDisabled('residentsSms', 'pickedUp') ? 'Please select email template first' : ''">
                                        <svg-checked></svg-checked>
                                    </label>
                                </label>
                                <span class="mtv-primary-color clickable-text"
                                      (click)="showNotificationModal('residentsSms', 'pickedUp')">
                                    Parcel Picked Up
                                </span>
                            </div>
                            <div class="m-b-xs filter-checkbox">
                                <label class="img-checkbox">
                                    <input type="checkbox"
                                           id="parcelReturnedSmsResidentCheckbox"
                                           name="parcelReturnedSmsResidentCheckbox"
                                           [(ngModel)]="settingsParcelsService.parcelReturnedSmsResidentCheckbox"
                                           [disabled]="smsCheckboxDisabled('residentsSms', 'returned')"
                                           (change)="submitNotificationsField()">
                                    <label for="parcelReturnedSmsResidentCheckbox"
                                           [title]="smsCheckboxDisabled('residentsSms', 'returned') ? 'Please select email template first' : ''">
                                        <svg-checked></svg-checked>
                                    </label>
                                </label>
                                <span class="mtv-primary-color clickable-text"
                                      (click)="showNotificationModal('residentsSms', 'returned')">
                                    Parcel Returned
                                </span>
                            </div>
                            <div class="m-b-xs filter-checkbox">
                                <label class="img-checkbox">
                                    <input type="checkbox"
                                           id="parcelCanceledSmsResidentCheckbox"
                                           name="parcelCanceledSmsResidentCheckbox"
                                           [(ngModel)]="settingsParcelsService.parcelCanceledSmsResidentCheckbox"
                                           [disabled]="smsCheckboxDisabled('residentsSms', 'canceled')"
                                           (change)="submitNotificationsField()">
                                    <label for="parcelCanceledSmsResidentCheckbox"
                                           [title]="smsCheckboxDisabled('residentsSms', 'canceled') ? 'Please select email template first' : ''">
                                        <svg-checked></svg-checked>
                                    </label>
                                </label>
                                <span class="mtv-primary-color clickable-text"
                                      (click)="showNotificationModal('residentsSms', 'canceled')">
                                    Parcel Canceled
                                </span>
                            </div>
                            <div class="m-b-xs filter-checkbox">
                                <label class="img-checkbox">
                                    <input type="checkbox"
                                           [(ngModel)]="settingsParcelsService.parcelModifiedSmsResidentCheckbox"
                                           name="parcelModifiedSmsResidentCheckbox"
                                           id="parcelModifiedSmsResidentCheckbox"
                                           [disabled]="smsCheckboxDisabled('residentsSms', 'modified')"
                                           (change)="submitNotificationsField()">
                                    <label for="parcelModifiedSmsResidentCheckbox"
                                           [title]="smsCheckboxDisabled('residentsSms', 'modified') ? 'Please select email template first' : ''">
                                        <svg-checked></svg-checked>
                                    </label>
                                </label>
                                <span class="mtv-primary-color clickable-text"
                                      (click)="showNotificationModal('residentsSms', 'modified')">
                                    Parcel Modified
                                </span>
                            </div>
                            <div class="m-b-md filter-checkbox">
                                <label class="img-checkbox">
                                    <input type="checkbox"
                                           [(ngModel)]="settingsParcelsService.parcelDeletedSmsResidentCheckbox"
                                           name="parcelDeletedSmsResidentCheckbox"
                                           id="parcelDeletedSmsResidentCheckbox"
                                           [disabled]="smsCheckboxDisabled('residentsSms', 'deleted')"
                                           (change)="submitNotificationsField()">
                                    <label for="parcelDeletedSmsResidentCheckbox"
                                           [title]="smsCheckboxDisabled('residentsSms', 'deleted') ? 'Please select email template first' : ''">
                                        <svg-checked></svg-checked>
                                    </label>
                                </label>
                                <span class="mtv-primary-color clickable-text"
                                      (click)="showNotificationModal('residentsSms', 'deleted')">
                                    Parcel Deleted
                                </span>
                            </div>
                            <div class="m-b-xs filter-checkbox">
                                <label class="img-checkbox">
                                    <input type="checkbox"
                                           id="isSendSmsOnlyIfEmailIsEmpty"
                                           name="isSendSmsOnlyIfEmailIsEmpty"
                                           [(ngModel)]="settingsParcelsService.selectedItemData.isSendSmsOnlyIfEmailIsEmpty"
                                           [disabled]="!settingsParcelsService.smsSettings?.isEnable"
                                           (change)="onSubmit({isSendSmsOnlyIfEmailIsEmpty: form.value.isSendSmsOnlyIfEmailIsEmpty ? 1 : 0})">
                                    <label for="isSendSmsOnlyIfEmailIsEmpty">
                                        <svg-checked></svg-checked>
                                    </label>
                                </label>
                                <span class="mtv-primary-color clickable-text">
                                    Send SMS when email is absent
                                </span>
                            </div>

                            <hr>

                            <div>
                                <span class="mtv-primary-color clickable-text" (click)="showSmsReminderTextModal()">
                                    Sms Reminder Text
                                </span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div *ngIf="!settingsParcelsService.selectedItemData">
                <spinner [spinnerShow]="true"></spinner>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-parcels/settings-parcels-detailed-view/settings-parcels-detailed-view.component.html